import { CLEAN_SIGNING_DEPLOYMENTS } from "./signingDeployments";

type SigningContext = Readonly<{
  chainId: string;
  proxyAddress: string;
  walletAddress: string;
}>;

export const walletDerivationMessage = (context: SigningContext): string => {
  const cleanWording = CLEAN_SIGNING_DEPLOYMENTS.some(
    (deployment) =>
      deployment.chainId === context.chainId &&
      deployment.proxyAddress === context.proxyAddress
  );
  if (cleanWording) {
    // These exact bytes become part of wallet identity at launch. Do not
    // translate, personalize or revise the text for an activated deployment.
    return [
      "Sign in to Redacted",
      "",
      "Unlock your private account. This signature does not send a transaction or charge a network fee.",
      "",
      `Network: ${context.chainId}`,
      `Redacted contract: ${context.proxyAddress}`,
      `Wallet: ${context.walletAddress.toLowerCase()}`,
    ].join("\n");
  }
  // Preserve the complete original payload, including case and serialization.
  return JSON.stringify([
    "REDACTED_V2_KEY_DERIVATION",
    context.chainId,
    context.proxyAddress,
    context.walletAddress.toLowerCase(),
  ]);
};
